export default __webpack_public_path__ + "static/media/vn-3.2fea01a0.jpg";